function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { ApiKey } from './api-key';
export class AuthService {
    static getInstance() {
        if (!AuthService.instance) {
            AuthService.instance = new AuthService();
        }
        return AuthService.instance;
    }
    initializeAuthState() {
        const apiKeyExists = ApiKey.exists();
        if (!this.authState && apiKeyExists) {
            this.authState = true;
        }
    }
    getAuthState() {
        return this.authState;
    }
    setAuthState(state) {
        this.authState = state;
        this.listeners.forEach((listener)=>listener(state));
    }
    subscribe(listener) {
        this.listeners.push(listener);
        return ()=>{
            this.listeners = this.listeners.filter((l)=>l !== listener);
        };
    }
    clearAuth() {
        this.setAuthState(false);
    }
    constructor(){
        _define_property(this, "authState", false);
        _define_property(this, "listeners", []);
        this.initializeAuthState();
    }
}
_define_property(AuthService, "instance", void 0);
export const authService = AuthService.getInstance();
